import { quickFilterApi } from "@/api/quickFilter";

import { QuickFilter } from "@/types/QuickFilter";

interface QuickFilterState {
  list: QuickFilter[];
}

const actions = {
  async list({ commit }) {
    const list: QuickFilter[] = await quickFilterApi.get();

    commit("setList", list);
  },
  async update({ dispatch }, quickFilterList: QuickFilter[]) {
    await quickFilterApi.put(quickFilterList);
    await dispatch("list");
  },
};

const getters = {};

const mutations = {
  setList(state, list: QuickFilter[]) {
    state.list = list;
  },
};

const state: QuickFilterState = {
  list: [],
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
